// export const url = "https://xtratoys.nextechltd.in/api";
//export const url = "https://centralskia.nextechltd.in/api";

 export const url = "https://democpos.nextechltd.in/api";
// export const url = "http://localhost:8000/api";
export const isAdmin = true;

export const adminUrl = "https://admindev.nextechltd.in/api";
